import { useTheme } from "@mui/material/styles";
import { useMemo } from "react";

import { useCoreChart } from "~/feature/chart/providers/CoreChartProvider";

import { buildChartLines } from "./buildChartLines";
import { getXAxis, getYAxis, toLineSeries } from "./chartOptions";
import { getYAxisRange } from "./yAxisRange";

export const useChartLines = () => {
  const { markets, selections, chanceHistory, timeline, viewMode, settings } =
    useCoreChart();
  const theme = useTheme();
  const consensusColor = theme.palette.gold.dark;
  const { autoscale } = settings;

  return useMemo(() => {
    const lines = buildChartLines({
      markets,
      selections,
      chanceHistory,
      timeline,
      viewMode,
      consensusColor,
    });

    return {
      xAxis: getXAxis(timeline),
      yAxis: getYAxis(getYAxisRange(lines, autoscale)),
      series: lines.map(toLineSeries),
      lineStyles: lines.map(({ key, variant }) => ({ key, variant })),
    };
  }, [
    autoscale,
    chanceHistory,
    consensusColor,
    markets,
    selections,
    timeline,
    viewMode,
  ]);
};
